import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext, FireactContext, SetPageTitle } from "../lib/core";

const DiditCallback = () => {
  const { authInstance, firestoreInstance, functionsInstance, authUser } = useContext(AuthContext);
  const { config } = useContext(FireactContext);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Callback loaded");
    window.parent.postMessage("diditVerificationComplete", "*");
  }, []);

  return (
    <div>
      <p>Verification complete. You can close this window.</p>
    </div>
  );
};

export default DiditCallback;

